import { useStaticQuery, graphql } from 'gatsby'

export const useServiceLogos = () => {

  const { services } = useStaticQuery(
    graphql`
      query ServiceLogoQuery {
        services: allServices {
          edges {
            node {
              name
              logo {
                cdn
              } 
            }
          }
        }
      }
    `
  )
  // const find = ({ id = null, name = null }) => {
  //   const key = id || name
  //   const result = allTaxonomyTermServices.edges.find(({ node }) => {
  //     return node.drupal_id === key || node.name.toLowerCase() === key
  //   })
  //   const node = result ? result.node : false
  //   if (node && node.relationships.field_servicelogo.localFile) {
  //     return {
  //       url: node.relationships.field_servicelogo.localFile.publicURL,
  //       name: node.name
  //     }
  //   } else {
  //     return { url: '', name: 'File does not exist' }
  //   }
  // }

  return services.edges 
}